(function () {
  'use strict';

  /* @ngdoc object
   * @name crewVoyageReport
   * @description
   *
   */
  angular
    .module('crewVoyageReport', [
      'ui.router'
    ]);
}());
